import api from './client';

/**
 * Fetch all stores. When backend supports multi-store, this returns the list.
 * Until then, backend may return [] or a single default store.
 */
export async function fetchStores() {
  const { data } = await api.get('/api/stores');
  return Array.isArray(data) ? data : [];
}

/**
 * Fetch a single store by ID.
 */
export async function fetchStoreById(id) {
  const { data } = await api.get(`/api/stores/${id}`);
  return data;
}

/**
 * Create a new store.
 */
export async function createStore(payload, authConfig) {
  const { data } = await api.post('/api/stores', payload, authConfig);
  return data;
}

/**
 * Update an existing store.
 */
export async function updateStore(id, payload, authConfig) {
  const { data } = await api.put(`/api/stores/${id}`, payload, authConfig);
  return data;
}
